// extracted by mini-css-extract-plugin
export default {"updateProfileBtnWrapper":"u4F9jw5VmuBeXjTZCewN","updateProfileBtn":"jYe6556ue08sbPjY2aE_"};